// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"14be81ee","221":"442d35fc","225":"f719134e","239":"ad40150f","455":"b3a86ed0","495":"cf6cb22f","552":"c071d2e3","564":"496e4bf1","722":"13d29cd0","840":"7ac4fd1f","900":"e55fad9c","977":"6a7f6471"}[chunkId] + ".chunk.js";
};